export const playbookRiskReportFormatter = (
  playbookData: any[],
  typeOfPlaybook: string,
) => {
  const SidebarColumnData: any = [];

  if (typeOfPlaybook === 'purchasing_standards') {
    playbookData?.map((data: any) => {
      const all_clauses: any = [];

      data?.all_clauses?.map((clause: any) => {
        all_clauses.push(clause.clause_name);
      });

      SidebarColumnData.push({
        standard_id: data.standard_id,
        clauses: all_clauses,
        content: ['Objectives', 'Importance', 'Clauses'],
      });
    });
  } else {
    playbookData?.map((data: any) => {
      data?.topics?.map((topic: any) => {
        const all_clauses: any = [];

         
        topic?.checkOfflist?.map((checkOff: any) =>
          all_clauses.push(checkOff.question),
        );

        SidebarColumnData.push({
          standard_id: topic.standard_id,
          clauses: all_clauses,
          content:
            typeOfPlaybook === 'regulatory_compliance'
              ? ['About', 'Questions']
              : ['Aim', 'Checkoff List'],
        });
      });
    });
  }

  return SidebarColumnData;
};

export const playbookSampleClauseFormatter = (sampleClause: any[]) => {
  const sampleClauseData: any[] = [];
  sampleClause.map((clauseItem) => {
    const main: any[] = [];
    const subData: any[] = [];

    Object.entries(clauseItem?.main).map((mainItem) => {
      main.push(mainItem[1]);
    });
    Object.entries(clauseItem?.sub_data).map((subItem) => {
      subData.push(subItem[1]);
    });
    sampleClauseData.push({ main, subData });
  });
  return sampleClauseData;
};

export const PlaybookAddQuestion = (
  playbookData: any[],
  updatedCheckOffList: any,
) => {
  const standard = playbookData.find(
    (item) => item.standard_id === updatedCheckOffList.standard_id,
  );

  if (standard) {
    const clause = standard.all_clauses.find(
      (clause: any) => clause.clause_id === updatedCheckOffList.clause_id,
    );

    if (clause) {
      clause.checkOffList = updatedCheckOffList.check_off_list;
    }
  }

  return playbookData;
};

export const PlaybookIgnoreClause = (
  playbookData: any[],
  updatedClause: any,
) => {
  const standard = playbookData.find(
    (item) => item.standard_id === updatedClause.standard_id,
  );

  if (standard) {
    const clause = standard.all_clauses.find(
      (clause: any) => clause.clause_id === updatedClause.clause_id,
    );

    if (clause) {
      clause.ignore = updatedClause.ignore;
    }
  }

  return playbookData;
};

export const PlaybookGagClauseFormatter = (gagClauseInfo: any) => {
  const questionSequence = [
    'What is this?',
    'Plans must have access to the following data',
    'Why must Plans have access to this data?',
  ];
  const keyDatesSequence = [
    'First attestation due',
    'Attestation Period',
    'Attestation Liability',
    'Penalties',
  ];
  const sequenceMap: { [key: string]: number } = questionSequence.reduce(
    (map, question, index) => {
      map[question] = index;
      return map;
    },
    {} as { [key: string]: number },
  );

  const gagCompliance = gagClauseInfo?.gagCompliance?.sort((a: any, b: any) => {
    return sequenceMap[a.question] - sequenceMap[b.question];
  });

  const sequenceMapKeyDates: {
    [key: string]: number;
  } = keyDatesSequence.reduce((map, key, index) => {
    map[key] = index;
    return map;
  }, {} as { [key: string]: number });

  const gagKeyValues = gagClauseInfo?.gagKeyValues?.sort((a: any, b: any) => {
    return sequenceMapKeyDates[a.key] - sequenceMapKeyDates[b.key];
  });

  return {
    gagCompliance,
    gagKeyValues,
  };
};

export const PlaybookCompensationTransparencyFormatter = (
  compensationTransparencyInfo: any,
) => {
  const questionSequence = [
    'What is this?',
    'Which plans are required to comply? ',
    'Which Contracts/Services does it apply to?',
    'What to do?',
    'When to do it?',
  ];

  const sequenceMap: { [key: string]: number } = questionSequence.reduce(
    (map, question, index) => {
      map[question] = index;
      return map;
    },
    {} as { [key: string]: number },
  );

  return compensationTransparencyInfo.sort((a: any, b: any) => {
    return sequenceMap[a.question] - sequenceMap[b.question];
  });
};
